<template>
    <router-link :to="homeURL()" id="logo" :style="[getContinuousAnimation]">
        <img src="@/assets/img/ui/logo.svg">
    </router-link>
</template>
<script>
export default {
    data() {
        return {
            globalData: undefined,
        };
    },
    mounted() {
        this.globalData = app.api.PageManager.getCustomComponentFromType('globalData');
    },
    methods: {
        homeURL() {
            if(app.api.PageManager.onHomePage() && this.overviewURL)
                return app.api.PageManager.getRootPage().route + ":" + this.overviewURL;
            else
                return app.api.PageManager.getRootPage().route;
        },
        getRandomAnimationDelay(min, max) {
            //return a random value for randomly timed animations
            return Math.random() * (max - min) + min;
        },
    },
    computed: {
        overviewURL() {
            if (this.globalData?.data?.overviewContent)
                return app.api.PageManager.getContentComponentFromID(this.globalData?.data?.overviewContent).slug
        },
        getContinuousAnimation() {
            this.$route;
            if(app.api.PageManager.onHomePage() && this.overviewURL)
                return {
                    'animation-name': "loopPulse",
                    'animation-iteration-count': 'infinite',
                    'animation-duration': '15s',
                    'animation-delay': this.getRandomAnimationDelay(2, 14).toFixed(1) + 's'
                }
        }
    }
}
</script>
<style lang="scss">
#logo {
    position: absolute;
    top: 40px;
    left: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 300px;
    min-height: 100px;
    background-color: var(--light-grey);
    border: 1px solid var(--secondary-color);
    border-radius: 16px;
    filter: drop-shadow(0px 3px 6px #00000029);

    z-index: 2;
    cursor: pointer;
    transition: background-color 0.2s ease-in-out;

    &>img {
        width: auto;
        height: 50px;
    }

    &:hover { background-color: #EEE; }

}

/* pulse animation */
@keyframes loopPulse {
    0% {
        box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4);
        transform: scale(1.1);
    }

    7% {
        box-shadow: 0 0 0 120px rgba(255, 255, 255, 0);
        transform: scale(1.02);
    }

    10% {
        box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
        transform: scale(1);
    }

    100% {
        box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
        transform: scale(1);
    }
}
</style>